import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCode3Line = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.99076 3.89729C4.97547 2.84115 6.37768 2.25 8.03313 2.25H16.4678C18.1272 2.25 19.5296 2.84086 20.5134 3.89773C21.4916 4.94853 22 6.39899 22 8.02638V15.9736C22 17.6014 21.4916 19.052 20.5132 20.1027C19.5292 21.1595 18.1265 21.75 16.4669 21.75H8.03313C6.3739 21.75 4.97126 21.1595 3.98717 20.1028C3.0087 19.0521 2.5 17.6015 2.5 15.9736V8.02638C2.5 6.39795 3.01147 4.9476 3.99076 3.89729ZM5.08786 4.9202C4.41042 5.64678 4 6.70962 4 8.02638V15.9736C4 17.2919 4.40882 18.3545 5.08488 19.0805C5.75534 19.8004 6.74426 20.25 8.03313 20.25H16.4669C17.7563 20.25 18.7452 19.8004 19.4154 19.0805C20.0914 18.3546 20.5 17.292 20.5 15.9736V8.02638C20.5 6.70857 20.0914 5.64585 19.4155 4.91976C18.7452 4.19973 17.7566 3.75 16.4678 3.75H8.03313C6.74924 3.75 5.75988 4.19944 5.08786 4.9202Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.7188 8.82123C11.0117 9.11413 11.0117 9.589 10.7188 9.88189L8.59972 12.001L10.7188 14.12C11.0117 14.4129 11.0117 14.8878 10.7188 15.1807C10.4259 15.4736 9.95103 15.4736 9.65814 15.1807L7.00873 12.5313C6.86808 12.3906 6.78906 12.1999 6.78906 12.001C6.78906 11.8021 6.86808 11.6113 7.00873 11.4706L9.65814 8.82123C9.95103 8.52834 10.4259 8.52834 10.7188 8.82123Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.7831 8.82123C14.076 8.52834 14.5509 8.52834 14.8438 8.82123L17.4932 11.4706C17.6339 11.6113 17.7129 11.8021 17.7129 12.001C17.7129 12.1999 17.6339 12.3906 17.4932 12.5313L14.8438 15.1807C14.5509 15.4736 14.076 15.4736 13.7831 15.1807C13.4903 14.8878 13.4903 14.4129 13.7831 14.12L15.9022 12.001L13.7831 9.88189C13.4903 9.589 13.4903 9.11413 13.7831 8.82123Z",
			fill: "currentColor"
		})
	]
});
export default SvgCode3Line;
